import React, { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { Button, Card, Col, Toast, OverlayTrigger,Tooltip } from "react-bootstrap";
import { notificationHubService } from "../../config/apiConfig";
import moment from "moment";
import { useNotification } from "../../ContentRoutes";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { markAsReadNotification } from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { toast } from "react-toastify";
 
function NotificationComponent({show,setShow}) {
  const toggleShowA = () => setShow(showA=>!showA);
  const {notifications, setNotifications}=useNotification()
  console.log('notifications: ', notifications);
  return (
   <div className="position-absolute  end-0 bottom-0 z-8 m-4" style={{zIndex:1000}}>
    <div  className="mb-2">
        <Toast style={{minHeight:"350px"}} position={'bottom-end'} show={show} onClose={()=>toggleShowA()}>
          <Toast.Header  closeVariant="dark" className="border-0">
            <div className="rounded-circle d-flex mx-3 justify-content-center align-items-center" style={{backgroundColor:"#2D475C",color:"#fff" ,width:"48px",height:"48px"}}>
            <img src={"/images/Notification_icon.svg"}  className="mx-2 w-50" />
            </div>
            <h5 className="me-auto">{notifications.at(0)?.header}</h5>
            {/* <small>{moment(notifications.at(0)?.time).fromNow()}</small> */}
          </Toast.Header>
          <Toast.Body className="">
          <strong className="d-block">{notifications.at(0)?.header}</strong>
            {notifications.at(0)?.message}</Toast.Body>
        </Toast>
      </div>
   </div>
  );
};
export const NotificationDrawer=({showDrawer,setShowDrawer})=>{
  const {notifications, setNotifications}=useNotification()
  const handleMarkAsRead = async(item) => {
    try{await sbaAxios({
      url: markAsReadNotification,
      params:{notificationId: item.nId, notificationRefNumber: item.nRefNum, markAll:false}
    })
    setNotifications((prev) =>
      prev.filter((notif) => {
        if (item.nId && item.nId > 0) {
          return notif.nId !== item.nId;
        }
        return notif.nRefNum !== item.nRefNum;
      })
    );
    toast.success("Notification Marked as read.")
  }
    catch{
      setNotifications((prev)=> [...prev])
      toast.error("Something went wrong.")
    }
  }

  const handleMarkAllRead = async() => {
    try{
      await sbaAxios({
      url: markAsReadNotification,
      params:{notificationId: null, notificationRefNumber: null, markAll:true}
    });
    setNotifications(val=>[]);
    setShowDrawer(val=>false);
    toast.success('All Notifications marked as read.')
  }
  catch(e){
    setNotifications(val=>[...val]);
    setShowDrawer(val => true)
    toast.error('Something went wrong')
  }
  }
return <>
<SBADrawer open={showDrawer} setOpen={setShowDrawer} closeButton={false} HeaderClassName="px-4" title={<>
<div className="d-flex gap-2">
<img src={"/images/Notification_icon_black.svg"}  className="mt-2"/>
<h3 className="m-0 mt-auto">Notification</h3>
  <span className="ms-auto SBA_hand" onClick={()=>{
    
    handleMarkAllRead();
  }}>Clear All</span>
</div>
</>}>
{notifications.map(item=>(<>
  <div className="notification-card-group my-3 position-relative">
  <Card>
  <Card.Header className="d-flex align-items-center justify-content-between border-0 position-relative flex-column align-items-start">
  <div className="d-flex justify-content-between w-100 align-items-center">
    <h5 className="mb-0">{item.header}</h5>
    <small>{moment(item.time).fromNow()}</small>
  </div>

  {/* Mark as read icon below the time */}
  {item.isRead!==true?
  <i
  className="fa-solid fa-times text-danger fs-5 mark-read-btn"
  style={{
    cursor: "pointer",
    display: "none",
    marginTop: "4px",
    alignSelf: "flex-end",
  }}
  title="Mark as read"
  onClick={() => handleMarkAsRead(item)}
></i>:<></>}
</Card.Header>
    <Card.Body className="p-2">
      <Card.Text className="p-2">
            {item?.message}
      </Card.Text>
    </Card.Body>
  </Card>
</div>
</>))}
</SBADrawer>
</>
};

export default NotificationComponent;